import { useMemo } from "react";
import { useHasOrgContext } from "../../../../common/auth/useHasOrgContext";
import { urls } from "../../../../urls";
import type { WizardStepPath } from "../../../../common/wizard/wizardStepPaths";

const asHref = ({ pathname, search }: WizardStepPath) => `${pathname}?${search}`;

export const useContributionUrls = () => {
  const hasOrgContext = useHasOrgContext();
  return useMemo(
    () =>
      hasOrgContext
        ? {
            list: urls.app.supplier.contributions,
            view: (contributingEntityId: string) => urls.app.supplier.contribution.go(contributingEntityId),
            steps: (contributingEntityId: string) => urls.app.supplier.contribution.steps(contributingEntityId),
            review: (bidId: string, contributingEntityId: string) =>
              urls.app.supplier.contributionReview.go(bidId, contributingEntityId),
            reviewSteps: (bidId: string, contributingEntityId: string) =>
              urls.app.supplier.contributionReview.steps(bidId, contributingEntityId),
            bidSupplierStep: (eventId: string, bidId: string) =>
              asHref(urls.app.supplier.bid.edit.go(eventId, bidId).supplier),
          }
        : {
            list: urls.portal.contributions,
            view: (contributingEntityId: string) => urls.portal.contribution.go(contributingEntityId),
            steps: (contributingEntityId: string) => urls.portal.contribution.steps(contributingEntityId),
            review: (bidId: string, contributingEntityId: string) =>
              urls.portal.contributionReview.go(bidId, contributingEntityId),
            reviewSteps: (bidId: string, contributingEntityId: string) =>
              urls.portal.contributionReview.steps(bidId, contributingEntityId),
            bidSupplierStep: (eventId: string, bidId: string) =>
              asHref(urls.portal.bid.edit.go(eventId, bidId).supplier),
          },
    [hasOrgContext],
  );
};
